export default "__VITE_ASSET__DahgqQZc__"